// document.addEventListener('DOMContentLoaded', function () {
//     const section = document.querySelector('.text-with-animation');
//     if (section) {
//         const wrappers = section.querySelectorAll('.wrapper');

//         // Clone text elements within each wrapper individually
//         wrappers.forEach(wrapper => {
//             const scrollText = wrapper.querySelector('.scroll-text');
//             if (scrollText) {
//                 for (let i = 0; i < 50; i++) {
//                     const clone = scrollText.cloneNode(true);
//                     wrapper.appendChild(clone); // Append each clone to the current wrapper
//                 }
//             }
//         });

//         // Define different speeds and translation values for each wrapper
//         const animationSpeeds = [3, 2.5]; // Different speeds for each wrapper
//         let translateX = []; // Separate translateX value for each wrapper
//         const textWidths = []; // Width of the combined scroll texts in each wrapper

//         // Initialize translateX and text widths for each wrapper
//         wrappers.forEach((wrapper, index) => {

//             translateX[index] = window.innerWidth / 4; // Starting position for each wrapper
//             let textWidth = 0;

//             // Calculate the combined width of the scroll texts in each wrapper
//             wrapper.querySelectorAll('.scroll-text').forEach(scrollText => {
//                 textWidth += scrollText.offsetWidth;
//             });
//             textWidths[index] = textWidth;
//         });

//         let animationRunning = true;

//         const setAnimationSpeeds = () => {
//             // Adjust speed for responsiveness
//             animationSpeeds[0] = window.innerWidth < 768 ? 1 : 3;
//             animationSpeeds[1] = window.innerWidth < 768 ? 0.9 : 2.7;
//         };

//         const animateText = () => {
//             const windowWidth = window.innerWidth;

//             const animate = () => {
//                 wrappers.forEach((wrapper, index) => {
//                     // Update the translateX position based on each wrapper's speed
//                     translateX[index] -= animationSpeeds[index];

//                     // Reset position if the wrapper has moved completely off-screen
//                     if (translateX[index] <= -textWidths[index]) {
//                         translateX[index] = windowWidth;
//                     }

//                     // Apply translation to each wrapper individually
//                     wrapper.style.transform = `translateX(${translateX[index]}px)`;
//                 });

//                 // Continue the animation if running
//                 if (animationRunning) {
//                     requestAnimationFrame(animate);
//                 }
//             };

//             requestAnimationFrame(animate);
//         };

//         const observerOptions = {
//             root: null,
//             threshold: 0.1,
//         };

//         const observerCallback = (entries) => {
//             entries.forEach(entry => {
//                 if (entry.isIntersecting) {
//                     if (!animationRunning) {
//                         animationRunning = true;
//                         animateText();
//                     }
//                 } else {
//                     if (animationRunning) {
//                         animationRunning = false;
//                     }
//                 }
//             });
//         };

//         const observer = new IntersectionObserver(observerCallback, observerOptions);
//         observer.observe(section);

//         // Set initial speeds and start the animation
//         setAnimationSpeeds();
//         animateText();

//         // Adjust speeds on window resize
//         window.addEventListener('resize', setAnimationSpeeds);
//     }
// });

document.addEventListener('DOMContentLoaded', function () {
    const section = document.querySelector('.text-with-animation');
    if (section) {
        const wrappers = section.querySelectorAll('.wrapper');

        // Clone text elements within each wrapper individually
        wrappers.forEach(wrapper => {
            const scrollText = wrapper.querySelector('.scroll-text');
            if (scrollText) {
                for (let i = 0; i < 500; i++) {
                    const clone = scrollText.cloneNode(true);
                    wrapper.appendChild(clone); // Append each clone to the current wrapper
                }
            }
        });

        // Define different speeds and translation values for each wrapper
        const animationSpeeds = [3, 2.5]; // Different speeds for each wrapper
        let translateX = []; // Separate translateX value for each wrapper
        const textWidths = []; // Width of the combined scroll texts in each wrapper

        // Initialize unique starting translateX and text widths for each wrapper
        wrappers.forEach((wrapper, index) => {
            // Assign unique starting points for each wrapper
            translateX[index] = (window.innerWidth / 4) + (index * 400); // Starting position for each wrapper, with offset
            let textWidth = 0;

            // Calculate the combined width of the scroll texts in each wrapper
            wrapper.querySelectorAll('.scroll-text').forEach(scrollText => {
                textWidth += scrollText.offsetWidth;
            });
            textWidths[index] = textWidth;
        });

        let animationRunning = true;

        const setAnimationSpeeds = () => {
            // Adjust speed for responsiveness
            animationSpeeds[0] = window.innerWidth < 768 ? 1 : 2.8;
            animationSpeeds[1] = window.innerWidth < 768 ? 0.9 : 2.7;
        };

        const animateText = () => {
            const windowWidth = window.innerWidth;

            const animate = () => {
                wrappers.forEach((wrapper, index) => {
                    // Update the translateX position based on each wrapper's speed
                    translateX[index] -= animationSpeeds[index];

                    // Reset position if the wrapper has moved completely off-screen
                    if (translateX[index] <= -textWidths[index]) {
                        translateX[index] = windowWidth;
                    }

                    // Apply translation to each wrapper individually
                    wrapper.style.transform = `translateX(${translateX[index]}px)`;
                });

                // Continue the animation if running
                if (animationRunning) {
                    requestAnimationFrame(animate);
                }
            };

            requestAnimationFrame(animate);
        };

        const observerOptions = {
            root: null,
            threshold: 0.1,
        };

        const observerCallback = (entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    if (!animationRunning) {
                        animationRunning = true;
                        animateText();
                    }
                } else {
                    if (animationRunning) {
                        animationRunning = false;
                    }
                }
            });
        };

        const observer = new IntersectionObserver(observerCallback, observerOptions);
        observer.observe(section);

        // Set initial speeds and start the animation
        setAnimationSpeeds();
        animateText();

        // Adjust speeds on window resize
        window.addEventListener('resize', setAnimationSpeeds);
    }
});
